import React from 'react'

import ConfirmModal from 'components/ConfirmModal'

import type { DeliveryPerformanceCsvDownloadControllerReturn } from '../../hooks/useDeliveryPerformanceCsvDownloadController'
import { PeriodSection } from '../PeriodSection'
import { QuickPeriodSelectButtons } from '../QuickPeriodSelectButtons'
import { EncodingSelect } from '../EncodingSelect'
import styles from './style.module.css'

type Props = DeliveryPerformanceCsvDownloadControllerReturn

export const DeliveryPerformanceCsvDownloadView: React.FC<Props> = ({
  period,
  encodingType,
  isOverPeriod,
  isBeforeStartDate,
  isDisabled,
  isDownloading,
  isConfirmOpen,
  downloadError,
  setStartDate,
  setEndDate,
  setEncodingType,
  handleYesterdayClick,
  handleTodayClick,
  handleLastMonthClick,
  handleCurrentMonthClick,
  openConfirm,
  closeConfirm,
  handleDownload,
}) => {
  return (
    <div className={styles.page}>
      <div className={styles.inner}>
        <PeriodSection
          period={period}
          isOverPeriod={isOverPeriod}
          isBeforeStartDate={isBeforeStartDate}
          onStartDateChange={setStartDate}
          onEndDateChange={setEndDate}
        />

        <QuickPeriodSelectButtons
          onYesterday={handleYesterdayClick}
          onToday={handleTodayClick}
          onLastMonth={handleLastMonthClick}
          onCurrentMonth={handleCurrentMonthClick}
        />

        <EncodingSelect value={encodingType} onChange={setEncodingType} />

        {downloadError && (
          <p className={styles.errorText} role="alert">
            {downloadError}
          </p>
        )}

        <div className={styles.downloadButtonWrapper}>
          <button
            type="button"
            className={styles.downloadButton}
            disabled={isDisabled || isDownloading}
            onClick={openConfirm}
          >
            CSVダウンロード
          </button>
        </div>

        <ConfirmModal
          title="CSVファイルをダウンロードしますか？<br />ダウンロードには時間がかかる場合があります。"
          width={470}
          isOpen={isConfirmOpen}
          handleCancel={closeConfirm}
          handleConfirm={handleDownload}
        />
      </div>
    </div>
  )
}
